import React from 'react';
import { Row, Col, Form, Input } from 'antd';
import { Text } from '@/components/Typography';

const { TextArea } = Input;

interface CommentProps {
	disabled: boolean;
	onChangeComment: () => {};
}

export function Comment({ onChangeComment, disabled }: Readonly<CommentProps>) {
	return (
		<Row>
			<Col span={24}>
				<Text strong style={{ fontSize: '20px' }}>
					Comment:
				</Text>
			</Col>
			<Col span={24}>
				<Form.Item name="comment">
					<TextArea
						rows={4}
						showCount
						maxLength={5000}
						disabled={disabled}
						onChange={onChangeComment ?? null}
					/>
				</Form.Item>
			</Col>
		</Row>
	);
}
